/**
 * 判断是否是微信浏览器
 * */
export const isWxBrowser = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return true
  } else {
    return false
  }
}
/**
 * 判断是否是支付宝浏览器
 * */
export const isAliBrowser = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/alipaydefined/i) === 'alipaydefined') {
    return true
  } else {
    return false
  }
}

/**
 * @function isFubeiApp
 * @description 是否处于付呗 App WebView（原生桥可用）
 * @returns {boolean}
 */
export function isFubeiApp () {
  if (typeof window === 'undefined') return false
  // iOS H5 壳可能只有 BridgeYes，无 WebViewJavascriptBridge
  if (window.WebViewJavascriptBridge || window.bridgeYesApi) return true
  const ua = navigator.userAgent || ''
  return /FuBei|fubei|FBApp|FBWebView/i.test(ua)
}

/**
 * 判断是android还是ios
 * */
export const judgeDeviceType = () => {
  var ua = window.navigator.userAgent.toLocaleLowerCase()
  var isIOS = /iphone|ipad|ipod/.test(ua)
  var isAndroid = /android/.test(ua)
  return {
    isIOS: isIOS,
    isAndroid: isAndroid
  }
}
/**
 * 判断手机是android 还是 ios
 * */
export const mobileVersion = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'android'
  } else if (isIos) {
    return 'ios'
  } else {
    return 'windows'
  }
}

/**
 * @function normalizeAndroidScanOptions
 * @description 补齐 navTitle（type=10 自定义扫码页用）
 * @param {Object} options 扫码参数
 * @returns {Object}
 */
export function normalizeAndroidScanOptions (options) {
  if (!options || typeof options !== 'object') return options
  const next = { ...options }
  if (next.title && !next.navTitle) {
    next.navTitle = next.title
  }
  return next
}
